import { render, staticRenderFns } from "./singleShopSplitAction.vue?vue&type=template&id=63db0627&scoped=true"
import script from "./singleShopSplitAction.vue?vue&type=script&lang=js"
export * from "./singleShopSplitAction.vue?vue&type=script&lang=js"
import style0 from "./singleShopSplitAction.vue?vue&type=style&index=0&id=63db0627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db0627",
  null
  
)

export default component.exports